import { Tags } from 'rbh-merchant-core';
import { MartCategory } from './mart-category';
import { ProductPerpackAmount } from './product-perpack-product';
import { ProductPurchasingAmountLimit } from './product-purchasing-amount-limit';
import { ProductSizeProduct } from './product-size-product';
import { ProductWeightProduct } from './product-weight-product';

export class MartProduct {
  tagId?: number;
  tag?: Tags;
  productId?: number;
  productNameTH?: string;
  productNameEN?: string;
  productDescriptionTH?: string;
  productDescriptionEN?: string;
  productSKUId?: string;
  originalProductPrice?: number;
  productPrice?: number;
  promoStatus?: string;
  promoStartDate?: string;
  promoStartTime?: string;
  promoEndDate?: string;
  promoEndTime?: string;
  productPhoto?: string;
  productStatus?: string;
  // productQCStatus?: string;
  // productQCUpdatedDate?: string;
  // productRejectReason?: [];
  productCategory?: MartCategory;
  productWeightProduct?: ProductWeightProduct;
  productSizeProduct?: ProductSizeProduct;
  productPerpackAmount?: ProductPerpackAmount;
  productPurchasingAmountLimit?: ProductPurchasingAmountLimit;

  constructor(Obj: any = {}) {
    this.tagId = Obj.tagId;
    this.tag = Obj.tag;
    this.productId = Obj.productId;
    this.productNameTH = Obj.productNameTH;
    this.productNameEN = Obj.productNameEN;
    this.productDescriptionTH = Obj.productDescriptionTH;
    this.productDescriptionEN = Obj.productDescriptionEN;
    this.productSKUId = Obj.productSKUId;
    this.originalProductPrice = Obj.originalProductPrice;
    this.productPrice = Obj.productPrice;
    this.promoStatus = Obj.promoStatus;
    this.promoStartDate = Obj.promoStartDate;
    this.promoStartTime = Obj.promoStartTime;
    this.promoEndDate = Obj.promoEndDate;
    this.promoEndTime = Obj.promoEndTime;
    this.productPhoto = Obj.productPhoto;
    this.productStatus = Obj.productStatus;
    // this.productQCStatus = Obj.productQCStatus;
    // this.productQCUpdatedDate = Obj.productQCUpdatedDate;
    // this.productRejectReason = Obj.productRejectReason;
    this.productCategory = Obj.productCategory;
    this.productWeightProduct = Obj.productWeightProduct;
    this.productSizeProduct = Obj.productSizeProduct;
    this.productPerpackAmount = Obj.productPerpackAmount;
    this.productPurchasingAmountLimit = Obj.productPurchasingAmountLimit;
  }
}
